<p-table
  #dt
  [value]="tableData"
  [columns]="columns"
  size="small"
  responsiveLayout="scroll"
  [rowHover]="true"
  [rows]="pageSize"
  [totalRecords]="data.count"
  [lazy]="true"
  [customSort]="true"
  [sortField]="defaultSortField"
  [sortOrder]="defaultSortOrder"
  (onPage)="handlePage($event)"
  (onSort)="handleSort($event)"
  [paginator]="enablePagination"
>
  <ng-template *ngIf="filter" pTemplate="caption">
    <ng-container>
      <ng-container *ngTemplateOutlet="filter"></ng-container>
    </ng-container>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th *ngFor="let col of columns" [pSortableColumn]="col.orderable ? col.renderColumn : undefined" style="cursor: pointer">
        <ng-container *ngIf="!col.customColumn">
          {{ col.renderColumnDisplay }}
        </ng-container>

        <ng-container *ngIf="col.customColumn">
          <ng-container *ngTemplateOutlet="templateHeader; context: { $implicit: col }"></ng-container>
        </ng-container>

        <p-sortIcon *ngIf="col.orderable" [field]="col.renderColumn"></p-sortIcon>
      </th>
    </tr>

    <tr *ngIf="filterFields">
      <th *ngFor="let col of columns">
        <ng-container *ngIf="filterMap.has(col.renderColumn)">
          <p-columnFilter [field]="col.renderColumn" matchMode="contains" [showMenu]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <ng-container *ngTemplateOutlet="filterMap.get(col.renderColumn) ?? null; context: { $implicit: value, filter: filter }"> </ng-container>
            </ng-template>
          </p-columnFilter>
        </ng-container>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row let-i="rowIndex">
    <ng-container *ngIf="rowTemplate; else defaultRow">
      <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: row, index: i }"></ng-container>
    </ng-container>

    <ng-template #defaultRow>
      <tr (dblclick)="onDoubleClick(i)">
        <ng-container *ngTemplateOutlet="template; context: { $implicit: row }"></ng-container>
      </tr>
    </ng-template>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="columns.length" class="text-center text-info no-data-text-size">
        {{ noDataText }}
      </td>
    </tr>
  </ng-template>
</p-table>
